export default {
  title: "Challenges",
  sections: {
    challenges_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Challenges</div>  for engineering firms',
            text2: ' SEU offers solutions to current<br> and future challenges and provides<br> opportunities for innovators',
            image: '/seu/latest-assets/seu_23.jpg'
          }
        },
      }
    },
    challenges_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Your challenges'
          }
        }
      }
    },
    challenges_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_31.jpg'          }
        }
      }
    },
    challenges_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">Current challenges</span> in the Swiss engineering industry',
            text2: 'The challenges facing our field are well known – and there’s no sign of them letting up. On the contrary: Arranging a suitable succession of ownership that perfectly fulfills all the requirements is difficult. Many firms suffer from a lack of capital or qualified personnel – and sometimes both.'
          }
        },
        field_three: {
          value: {
            text: 'Business is a daily struggle against increasing cost pressures and falling margins, with fierce competition between international corporations and SMEs. On top of that are the challenges of ongoing digitalization.',
            text2: 'A heavy burden of responsibility is often shouldered by just a few people. Today, the flexibility of employees and management has to match the complexity of the challenges they face.',
            text3: 'Versatility, agility and acting in awareness of our responsibilities as well as a robust corporate culture contribute to mastering acute crises or energy-sapping demands. In this context, generational transition is also a major challenge.'
          }
        },
      }
    },
    challenges_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'What obstacles stand in your company\'s path?'
          }
        }
      }
    },
    challenges_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                name: 'Lack of qualified specialists',
                image: '/seu/latest-assets/seu_01.jpg',
                subTitle: 'The skilled labor market in Switzerland is like a desert. Are you investing hours of your time and a significant fraction of your budget to quench your thirst for qualified employees? Do you have to compete with larger companies by offering additional benefits to increase your attractiveness to prospective employees?\n' +
                  '<p>We’ve been there. <a href="/en/services#personnel_development" class="text-highlight" >Let’s solve this problem together</a>.</p>',
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Succession of ownership',
                image: '/seu/latest-assets/seu_02.jpg',
                subTitle: `Expertise, a sense of responsibility, personal commitment, a love of entrepreneurship and sufficient financial resources don’t always come together at the same time, unfortunately. Do you already have the perfect match to take your place in the professional driver’s seat? Are family members ready to step into your shoes – or have they opted for a different life path? Are you in discussion with investors – but you just can’t seem to get off the starting line?
<p>One thing is sure: You want to know that your life’s work is in good hands. <a href="/en/services#succession" class="text-highlight" >Together we can make it possible<a/>.</p>  `,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Competition',
                image: '/seu/latest-assets/seu_03.jpg',
                subTitle: `Tradition and success are on your side. But in a vast ocean of competition, sometimes that’s no longer enough. The big fish snatch up the big contracts. A full range of services – which small businesses can barely manage to provide anymore – overflow the scope of a single contract. And many small and medium competitors are locked in a bitter price war at the expense of profit. Margins are getting thin. But the collective intelligence of a group will get you <a href="/en/services#digitalization" class="text-highlight" >back on course</a>.</p>`,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Digitalization',
                image: '/seu/latest-assets/seu_04.jpg',
                subTitle: `There’s no question: Without robust IT, nothing works. But there’s more to it than that. Are you making targeted investments – and above all, investing enough so that talented employees in the field of BIM can take the pole position? Is your cybersecurity up-to-date to protect your company from hackers and IT blackmail? And how are your team’s technology skills?
<p> That’s a lot of questions that have to be addressed on many levels. Let’s <a href="/en/services#processes" class="text-highlight" >find the answers together<a/>.</p>`,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Cost pressures',
                image: '/seu/latest-assets/seu_05.jpg',
                subTitle: `Bigger, higher, farther – the engineering market is fiercely competitive. Unfortunately, the prices for your services don’t automatically rise along with the quality of your services. On the contrary: Market prices are increasingly dictated by large companies and global corporations. The downward spiral of high cost pressure and a lack of investment can also affect thriving SMEs and land them in economic turbulence. Do your margins still ensure security for the long term?
<p> Success needs investment. Don’t wait to make sure you have the  <a href="/en/services#management_support" class="text-highlight" > financial flexibility<a/> you need.</p> `,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Financing',
                image: '/seu/latest-assets/seu_06.jpg',
                subTitle: `The smaller the engineering firm, the harder it is to draw on reliable sources of financing. Be honest now: Have you ever thought about reaching into your family savings so that you could make an investment? Or are you struggling with ambitious growth plans so that you can remain competitive?
<p>Financing is a matter of trust. <a href="/en/services#management_support" class="text-highlight" > Tell us about your vision<a/>.</p>`,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },

            ]
          }
        }
      }
    },
    challenges_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Challenges'
          }
        }
      }
    },
    challenges_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: 'Swiss Engineers United offers an industry-specific solution'
          }
        },
        field_two: {
          value: {
            text: 'Our deepest conviction is that working closely with clients, growing sustainably and outstanding brand performance are possible even under difficult conditions.'
          }
        },
        field_three: {
          value: {
            text: 'As Swiss entrepreneurs with decades of expertise in the fields of structural and civil engineering and geomatics, we understand the challenges of our industry as well as an engineer understands his measurement, calculation and design tools. We know what’s important and how we can tackle the problems together.',
            text2: 'SEU opens doors – for new momentum, new paths, new partnerships, new collaborations and new growth. For example, the <a class="text-highlight" href="/en/strategy#best-practises"> HMQ Group</a>, the first SEU company, established an international offshore production facility for Switzerland.',
            text3: 'When it seems like the pressure is constantly increasing, while you’re only getting farther from accomplishing your goals – that’s then you need strong partnerships on an equal footing.'
          }
        },
      }
    },
    challenges_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'We’ll be right by your side',
            text2: 'With the power of our group dynamics.',
            buttonLabel: 'About us',
            buttonLink: '/en/about',
            image: '/seu/latest-assets/seu_35.jpg',
          }
        },
      }
    }
  }
}
